import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {useContext, useEffect} from "react";
import servicesRoute from "../../../tools/servicesRoute";
import Api from "../../../tools/service";
import Swal from "sweetalert2";
import AppContext from "../../../tools/contexts/AppContext";
import AuthContext from "../../../tools/contexts/AuthContext";

const TosanGate=()=>{
    const [searchParams] = useSearchParams();
    const ssoJwt=searchParams.get('ssoJwt');
    const {id,service}=useParams();
    const appContext=useContext(AppContext);
    const authContext=useContext(AuthContext);
    const navigate=useNavigate();
    const handleAuth = (data, callback = () => {
    }) => {
        appContext.handleLoading(true)
        Api.post('/api/v1/Auth/PlatformGuard', data).then(res => {
            if (!res.hasError) {
                callback(res.data)

            } else {
                appContext.handleLoading(false)
                Swal.fire({
                    allowOutsideClick: false,
                    text: res.message,
                    title: "ناموفق",
                    icon: 'error',
                    showCancelButton: false,
                    showConfirmButton: false,
                })
            }


        }).catch((e) => {
            appContext.handleLoading(false)
        }).finally((res) => {


        })
    }
    useEffect(()=>{
        if (ssoJwt && servicesRoute[service]) {
            handleAuth({
                "platform_hash_id": id,
                "service_type": service,
                "ssoJWT": ssoJwt
            }, (data) => {

                const myServices = servicesRoute[service];

                authContext.login({
                    personal_token: data.access_token,
                    ...data.platform_user,
                })


                if (myServices) {
                    appContext.handleLoading(false);
                    localStorage.setItem('t_token', data.access_token)
                    navigate(servicesRoute[service].path,{
                      state:{
                          token:data.access_token
                      }
                    })
                } else {
                    navigate('/404')
                }

            })

        } else {

            /*   navigate('/login')*/
        }
    },[])

    return <></>
}
export default TosanGate;